function getElementOffset(element){

	let pos={left:0, top:0, bottom:0};

	let parents=element.offsetParent;

	pos.left+=element.offsetLeft;
	pos.top+=element.offsetTop;

	while(parents && !/html|body/i.test(parents.tagName)){

		pos.left+=parents.offsetLeft;
		pos.top+=parents.offsetTop;

		parents=parents.offsetParent;
	}
	return pos;
}

export {
	getElementOffset
}
